import { TaskResponseType } from "ts/api/task";

export const TASK_STATUS_ENUM: Record<string, string> = {
  todo: "To Do",
  review: "Review",
  inReview: "In Review",
  waitingForApproval: "Waiting for Approval",
  revision: "Revision Required",
  done: "Done",
};

export const TASK_TYPE_MAP: Record<TaskResponseType, string> = {
  shortAnswer: "Short Answer",
  shortAnswerRows: "Short Answer (Rows)",
  paragraph: "Paragraph",
  multipleChoice: "Multiple Choice",
  checkboxes: "Checkboxes",
  check: "Check",
  files: "File Upload",
  grid: "Grid",
  multitask: "Multitask",
} as const;
